import { Link } from "react-router-dom";
import NavButton from "../components/shared/NavButton";
import styles from "./HomePageText.module.css";
import artists from "../data/artists";

function HomePageText() {

    let allArtists = "";
    let d = new Date();
    let year = d.getFullYear();

    function outputArtistList(artists) {
        artists.forEach((artist) => {
            if (artists.indexOf(artist) === (artists.length - 1)) {
                allArtists += artist;
            } else {
                allArtists += artist + ", "
            }
            return;
        })
    }

    outputArtistList(artists)

    return (
        <>
            <div className={styles.homeContainer}>
                <div className={styles.homeElements}>
                    <div className={styles.exhibitionTitle}>
                        <h1>Call Me<br />By Your Meme</h1>
                    </div>
                    <div className={styles.exhibitionVolumeNumber}>
                        <h3>Vol. 1</h3>
                    </div>
                    <div className={styles.curatedBy}>
                        <p>a research project by Nathan Gotlib</p>
                    </div>
                    <div className={styles.exhibitedArtists}>
                        with {allArtists}
                    </div>
                    <div className={styles.practicalInfo}>
                        <p>28.04 - 21.05.2023
                            <br />
                            M HKA Museum of Contemporary Art Antwerp, Belgium</p>
                    </div>
                    <div className={styles.openingDate}>
                        <p>Opening: 27.04, from 7 - 9 pm.</p>
                    </div>
                    <div className={styles.homeNavigationButtons}>
                        <Link to="/about">
                            <NavButton navButtonLabel="About ›" />
                        </Link>
                        <Link to="/gallery">
                            <NavButton navButtonLabel="Gallery ›" />
                        </Link>
                        <Link to="/bibliography">
                            <NavButton navButtonLabel="Bibliography ›" />
                        </Link>
                        <Link to="/submissions">
                            <NavButton navButtonLabel="Submissions ›" />
                        </Link>
                    </div>
                    <br />
                    <br />
                    <div className={styles.homeFooter}>
                        <p className={styles.footerPracticalInfo}>
                            <b>Practical information:</b>
                            <br />
                            M HKA Museum of Contemporary Art<br />Leuvenstraat 32, 2000 Antwerp, Belgium
                            <br />
                            <a href="https://mhka.be" target="_blank" rel="noopener noreferrer">www.muhka.be</a>
                        </p>
                        <p className={styles.curatorBio}>
                            <b>About the curator:</b>
                            <br />
                            <a href="https://nathangotlib.com" target="_blank" rel="noopener noreferrer">Nathan Gotlib</a> is a Belgian artist printmaker. He currently works as a studio coordinator at the <a href="https://fransmasereelcentrum.be/" target="_blank" rel="noopener noreferrer">Frans Masereel Centrum</a>, an international printmaking residency place in the Belgian countryside, and as a guide at the M HKA, Antwerp’s Museum of Contemporary Art. He runs his own <a href="https://rombus.be/" target="_blank" rel="noopener noreferrer">print studio</a> at Blikfabriek in Antwerp, Belgium.
                        </p>
                        <p className={styles.disclaimer}>
                            <b>Disclaimer:</b>
                            <br />
                            Due to general ethics regarding intellectual property and artistic licensing, all of the works generated by this project will not be sold or monetized in any way. This is a non-commercial research project and will remain so.
                        </p>
                        <p className={styles.press}>
                            <b>Press:</b>
                            <br />
                            For all press inquiries, please send an email to: <a href="mailto:CMBYMvol1@gmail.com?subject=Call Me By Your Meme vol.1 - Press inquiry">CMBYMvol1@gmail.com</a>
                        </p>
                        <p className={styles.projectCredits}>
                            <b>Credits:</b>
                            <br />
                            All images courtesy of the artists.
                            <br />
                            Texts and concept by Nathan Gotlib
                            <br />
                            © {year}, all rights reserved.
                        </p>
                        <p className={styles.websiteCredits}>
                            <b>Website design and development:</b>
                            <br />
                            <a href="https://www.zoeschreiber.be/portfolio" target="_blank" rel="noopener noreferrer">Zoé Schreiber</a>
                        </p>
                    </div>
                </div>
            </div>
        </>

    )
}
export default HomePageText;